import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import "./index.scss";

const CustomToastContainer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:900px)");

  return (
    <ToastContainer
      position={isMobile ? "top-center" : "top-left"}
      autoClose={5000}
      hideProgressBar
      rtl={"rtl"}
      toastStyle={{
        backgroundColor: theme.palette.error.main,
        color: theme.palette.white.main,
        width: "100%",
        direction: "rtl",
      }}
    />
  );
};

export default CustomToastContainer;
